export function scrollToRef(ref: React.RefObject<HTMLDivElement>, key?) {
  try {
    if (key&&extraFunctions[key]) extraFunctions[key]();
    window.scrollTo({
      top:
        ref.current.offsetTop -
        parseInt(
          getComputedStyle(document.documentElement).getPropertyValue("--header-height"),
          10
        ),
      behavior: "smooth",
    });
  } catch (e) {
    console.error(e);
  }
}

let scrollRefs: Record<string, React.RefObject<HTMLDivElement>> = {};
let extraFunctions: Record<string, Function> = {};

export function getScrollRefByKey(key: string) {
  return scrollRefs[key];
}

export function addScrollRef(key: string, newHistoryRef, extraFunction?) {
  scrollRefs[key] = newHistoryRef;
  extraFunctions[key] = extraFunction;
}
